import React from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import {
    IconContainer,
    RewardProgressTotalButtonWithIcon,
    RewardProgressTotalContainer,
} from './CircularProgressBar.styled';
import { NsTypography } from '@nuskin/foundation-ui-components';
import { RewardProgressBarProps } from './types';
import Info from '../Icons/Info';
import { Tooltip, IconButton } from '@mui/material';
import { replacePlaceholders } from '../Utils/helper';

class RewardSubscriptionTotal extends React.Component<RewardProgressBarProps> {
    render() {
        const {
            value,
            voucherValue,
            maxMonths,
            notQualifyForRewardThisMonth,
            amountShow,
            translationConfig = {
                voucherTargetAmount: '',
                monthsComplete: '',
                voucherEarned: '',
                learnMore: '',
                learn3xMore: '',
                callToAction: '',
                notQualify: '',
                approximateMonthly: '',
                approximateTotal: '',
                currentlyTrack: '',
                loyaltyLogoBlack: '',
                estimateDisclaimer: '',
            },
            storeConfig = {
                tiers: [
                    {
                        consecutive_months: 0,
                        min_spend: 0,
                        max_spend: 0,
                        promo_code: '',
                    },
                    {
                        consecutive_months: 0,
                        min_spend: 0,
                        promo_code: '',
                    },
                ],
            },
            currencyAbbreviate = false,
            currencyFormat = () => {},
        } = this.props;

        const voucherEarned = voucherValue
            ? currencyFormat(voucherValue, true, currencyAbbreviate)
            : currencyFormat(0, true, currencyAbbreviate);
        const currentlyTrackText = translationConfig.currentlyTrack.replace(
            '%currency_symbol%%currency_amount%',
            `${voucherEarned}`,
        );
        const approximateTotalText = replacePlaceholders(translationConfig.approximateTotal, {
            currency_symbol: '',
            projected_month_spend: '',
        });
        const minAmount = parseFloat(String(storeConfig?.tiers?.[0]?.min_spend)) || 0;
        const minAmountShow = currencyFormat(minAmount, true, currencyAbbreviate);
        const callToActionText = translationConfig.callToAction.replace(
            '%currency_symbol%%current_spend_target%',
            `${minAmountShow}`,
        );
        const approximateMonthlyText = replacePlaceholders(translationConfig.approximateMonthly, {
            currency_symbol: '',
            estimated_running_subscription_spend: '',
        });
        const amountShowText = currencyFormat(amountShow ?? 0, false, false);
        return (
            <RewardProgressTotalContainer>
                <RewardProgressTotalButtonWithIcon>
                    {notQualifyForRewardThisMonth ? (
                        <>
                            <IconContainer>
                                <FaExclamationTriangle className="loyalty-warning-icon" color="#4A6987" />
                            </IconContainer>
                            <NsTypography
                                variant="body-s"
                                weight="normal"
                                className="reward-subtitle"
                                colorOverride="#293A4A"
                                noSpacing
                            >
                                {translationConfig.notQualify}
                            </NsTypography>
                        </>
                    ) : (
                        <>
                            <NsTypography
                                variant="body-s"
                                weight="normal"
                                colorOverride="#252525"
                                className="reward-subtitle"
                                component="span"
                                noSpacing
                            >
                                {approximateMonthlyText}
                            </NsTypography>
                            &nbsp;
                            <NsTypography weight="bold" className="button-price" variant="body-s" component="span">
                                {`${amountShowText}`}
                            </NsTypography>
                            <IconContainer>
                                <Tooltip
                                    slotProps={{
                                        tooltip: {
                                            sx: {
                                                color: '#FFFFFF',
                                                backgroundColor: '#252525',
                                                fontFamily: 'Inter',
                                                fontWeight: 400,
                                                fontSize: '14px',
                                                lineHeight: '20px',
                                                '& .MuiTooltip-arrow': {
                                                    color: '#252525',
                                                },
                                            },
                                        },
                                    }}
                                    title={translationConfig.estimateDisclaimer}
                                    arrow
                                    placement="top"
                                >
                                    <span className="info-icon">
                                        <IconButton aria-label={translationConfig.estimateDisclaimer}>
                                            <Info />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </IconContainer>
                        </>
                    )}
                </RewardProgressTotalButtonWithIcon>
                {(() => {
                    if (value === maxMonths) {
                        return '';
                    } else if (notQualifyForRewardThisMonth) {
                        return (
                            <NsTypography
                                variant="body-s"
                                weight="normal"
                                className="reward-subtitle"
                                colorOverride="#252525"
                                component="div"
                            >
                                {approximateTotalText}&nbsp;
                                <NsTypography component="span" className="button-price" variant="body-s" weight="bold">
                                    {`${amountShowText}`}
                                </NsTypography>
                            </NsTypography>
                        );
                    } else if (voucherValue != null || voucherValue != undefined) {
                        return (
                            <NsTypography
                                variant="body-s"
                                weight="bold"
                                className="reward-subtitle"
                                colorOverride="#252525"
                            >
                                {currentlyTrackText}
                            </NsTypography>
                        );
                    } else {
                        return (
                            <NsTypography
                                variant="body-s"
                                weight="bold"
                                className="reward-subtitle"
                                colorOverride="#252525"
                            >
                                {callToActionText}
                            </NsTypography>
                        );
                    }
                })()}
            </RewardProgressTotalContainer>
        );
    }
}

export default RewardSubscriptionTotal;
export { RewardSubscriptionTotal };
